'use strict';

// Cargando elementos de bootstrap que se usarán en el sistema
import Datepicker from './angular-ui-bootstrap/src/datepicker';
import Datepickerpopup from './angular-ui-bootstrap/src/datepickerPopup';
import Dropdown from './angular-ui-bootstrap/src/dropdown';
import Accordion from './angular-ui-bootstrap/src/accordion';
import Alert from './angular-ui-bootstrap/src/alert';
import Buttons from './angular-ui-bootstrap/src/buttons';
import Modal from './angular-ui-bootstrap/src/modal';
import Popover from './angular-ui-bootstrap/src/popover';
import Tabs from './angular-ui-bootstrap/src/tabs';
import Timepicker from './angular-ui-bootstrap/src/timepicker';
import Tooltip from './angular-ui-bootstrap/src/tooltip';

import Waves from './waves/waves.module';
import Formly from './formly/formly.module';
import PDFObject from './PdfObject/PdfObject';

import './vendor.css';

const Vendor = angular
    .module('app.vendor', [
        Datepicker,
        Datepickerpopup,
        Dropdown,
        Accordion,
        Alert,
        Buttons,
        Modal,
        Popover,
        Tabs,
        Timepicker,
        Tooltip,
        Waves,
        Formly
    ])
    .directive('ngPdfObject', function () {
        return {
            replace: 'true',
            scope:{
                url : "@url",
                height: "@height",
                width: "@width"
            },
            template: '<div id="pdf"><div>',            
            link: function (scope, elem, attrs) {
                var options = {
                    pdfOpenParams: {
                        pagemode: "thumbs",
                        navpanes: 0,
                        toolbar: 0,
                        statusbar: 0,
                        view: "FitV"
                    }
                };
                var myPDF = PDFObject.embed(scope.url, "#pdf", options);         
                var el = document.querySelector("#results");
                // el.setAttribute("class", (myPDF) ? "success" : "fail");
                // el.innerHTML = (myPDF) ? "PDFObject successfully added an &lt;embed> element to the page!" : "Uh-oh, the embed didn't work.";
            }
        };
    })
    .name;

export default Vendor;



// WEBPACK FOOTER //
// ./src/app/common/core/vendor/vendor.module.js